import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";
import lazyload from "./features/lazy-load";
import stickyScroll from "./features/sticky-scroll";
lazyload();
stickyScroll();
initMain(
  [],
  {
    ForumPager: () => import("./vue/components/forum-pager/ForumPager.vue"),
    TrendsHorizontal: () =>
      import("./vue/components/trends/TrendsHorizontal.vue"),
  },
  []
);
header();
